<template>
  <div class="order-operations is-relative">
    <b-loading :is-full-page="false" :active="fetching"></b-loading>
    <b-modal :active.sync="modal.active" :width="'90vw'" has-modal-card>
      <order-operations-modal
        :order="order"
        :operation="modal.operation"
        :includes="$options.includes"
        @create-success="onOperationsModalCreateSuccess"
        @update-success="onOperationsModalUpdateSuccess"
      />
    </b-modal>
    <b-tabs v-model="tabs.active" @change="loadTab">
      <b-tab-item label="SUMMARY">
        <order-operation-summary
          v-if="order"
          :operations.sync="operations"
          :order="order"
          @updateOperaions="updateOperaions"
          :total="totalValueOfAllOperation"
        />
      </b-tab-item>

      <b-tab-item key="create" class="create-tab" v-if="createEnabled">
        <template slot="header">
          <b-button
            id="create_operation"
            type="is-light"
            size="is-small"
            class="is-fullwidth"
            :disabled="canManageOperations && !canManageOperations.value"
            :title="
              canManageOperations && !canManageOperations.value
                ? canManageOperations.help[0]
                : ''
            "
            @click.stop="create"
            v-if="canCreateOperations && canCreateOperations.value"
            >CREATE NEW</b-button
          >
        </template>
        No operations found.
      </b-tab-item>
      <b-tab-item key="toggleMode" class="toggle-mode-tab" v-if="createEnabled">
        <template slot="header">
          <b-button
            id="toggle_mode"
            type="is-light"
            size="is-small"
            class="is-fullwidth"
            @click.stop="toggleMode"
          >
            TOGGLE MODE
          </b-button>
        </template>
      </b-tab-item>

      <template v-if="mode == 'default'">

        <b-tab-item
          :label="`${operation.operationId || 'PENDING'}`"
          :key="operation.id"
          v-for="(operation, index) in sortedOperations"
        >
          <order-operation
            :order="order"
            :style="'padding:0;'"
            :operation="operation"
            :is-first="index == 0"
            :includes="$options.includes"
            @view-map="openOperationsModal"
            v-if="isTabLoaded(index + 3)"
            :ref="`operationTab${index}`"
            @order-operation-deleted="removeOperation"
          />
        </b-tab-item>
      </template>
      <b-tab-item label="LIST" v-else>
        <order-operations-list
          :order="order"
          :operations="sortedOperations"
          @order-operation-deleted="(op) => removeOperation(op, false)"
        />
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import OrderOperation from "./OrderOperation";
import OrderOperationsModal from "./OrderOperationsModal";
import { tabsMixin } from "@/mixins/tabsMixin";
import { CodeService } from "@/services/code.service";
import { OrderOperationService } from "@/services/orderOperation.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import OrderOperationSummary from "./OrderOperationSummary";
import OrderOperationsList from "./OrderOperationsList";

export default {
  codeService: CodeService,
  orderOperationService: OrderOperationService,
  includes:
    "outcomeCode,responsibilityCode,failureCode,repairCode,activityCode,ownerFirm,ownerFirm.permissions,asset,asset.site,orderOperationClaimLines,orderOperationClaimLines.wbsCode,maintenanceTask,form,form.formType,tags",
  props: {
    order: {
      required: true
    }
  },
  components: {
    OrderOperation,
    OrderOperationSummary,
    OrderOperationsModal,
    OrderOperationsList,
  },
  mixins: [tabsMixin],
  data: () => ({
    mode: "default",
    operations: [],
    modal: {
      operation: {},
      active: false
    },
    createEnabled: true,
    fetching: false,
    totalValueOfAllOperation: 0
  }),
  async created() {
    await this.fetch();
    // Set default tab
    this.loadTab(3);
    this.tabs.active = 3;
    // Pre-select tab
    this.$nextTick(() => {
      if (this.$route.query.operationId) {
        const index = this.sortedOperations.findIndex(
          (v) => v.operationId == this.$route.query.operationId
        );
        if (index > -1) {
          setTimeout(() => {
            this.loadTab(index + 3);
            this.tabs.active = index + 3;
          }, 100);
        }
      }
    });
  },
  watch: {
    operations: {
      handler: function() {
        this.$nextTick(() => {
          // Fix - Create tab stays in index 0
          this.createEnabled = false;
          this.$nextTick(() => {
            this.createEnabled = true;
          });

          this.$nextTick(() => {
            this.calculateOperationClaimLinesValue();
          });
          this.$emit("update:operations", this.operations);
        });
      },
      deep: true
    },
    "tabs.active"() {
      this.$nextTick(() => {
        this.setNotesHeight();
      });
    },
    sortedOperations(){
      if(this.sortedOperations.length > 0){
        // this.tabs.active = 1
      }
      this.mode = this.sortedOperations.length < 25 ? "default" : "list";
    }
  },
  computed:{
    sortedOperations(){
      const pending = this.operations.filter( operation => operation.operationId == null);
      const sorted = this.operations.filter( operation => operation.operationId != null).sort((a, b) => a.operationId - b.operationId);
      return sorted.concat(pending)
    },
    canManageOperations() {
      return this.$store.getters["OrderState/getStateByKey"](
        "can_manage_operations"
      );
    },
    canCreateOperations() {
      return this.$store.getters["OrderState/getStateByKey"](
        "can_create_operations_by_user"
      );
    }
  },
  methods: {
    toggleMode() {
      this.mode = this.mode == 'default' ? 'list' : 'default'
      this.tabs.active = 3;
    },
    setNotesHeight() {
      if (this.operations.length) {
        // this.$refs[`operationTab${this.tabs.active}`][0].setNotesHeight();
      }
    },
    async fetch() {
      if (this.order) {
        this.fetching = true;

        try {
          this.operations = await this.$options.orderOperationService
            .all({
              orderId: this.order.id,
              notIncludedStatus: 'CLOSED_N,REJECTED',
              includes: this.$options.includes,
              perPage: 10000,
            })
            .then(response => JsonDenormalizer.denormalize(response));
        } catch (err) {}

        this.fetching = false;
      }
    },
    async create() {
      this.creating = true;

      try {
        const operation = await this.$options.orderOperationService
          .create({ orderId: this.order.id })
          .then(response => JsonDenormalizer.denormalize(response));

        this.operations.push(operation);

        // Set order state
        this.$store.dispatch("OrderState/fetchState", this.order.id);

        this.$nextTick(() => {
          // No -1 to index because index 0 is occupied by summary tab
          this.tabs.active = this.sortedOperations.length + 2;
        });

        this.$buefy.toast.open({
          message: "Order operation has been created.",
          type: "is-info",
          position: "is-top-right"
        });
      } catch (err) {}

      this.creating = false;
    },
    update(operation) {
      let index = this.operations.findIndex(op => op.id === operation.id);

      if (index > -1) {
        this.$set(this.operations, index, operation);
      }
    },
    openOperationsModal(operation) {
      this.modal.operation = operation;
      this.modal.active = true;
    },
    onOperationsModalCreateSuccess(operation) {
      this.operations.push(operation);
    },
    onOperationsModalUpdateSuccess(operation) {
      this.update(operation);
    },
    updateOperaions(operations){
      // this.operations = operations

      operations.forEach(operation => {
        const foundIndex = this.operations.findIndex(_operation => _operation.id === operation.id);

        if (foundIndex > -1) {
          this.$set(this.operations[foundIndex], "ownerFirm", operation.ownerFirm);
          this.$set(this.operations[foundIndex], "ownerFirmId", operation.ownerFirmId);
        }
      });

      // Update operation tab forms
      this.sortedOperations.forEach((sortedOperation, index) => {
        this.$refs[`operationTab${index}`][0].setForm();
      });
    },
    calculateOperationClaimLinesValue() {
      let total = 0;
      this.operations.forEach(operation => {
        if (operation.orderOperationClaimLines) {
          operation.orderOperationClaimLines.forEach(claimLine => {
            total =
              total +
              claimLine.orderOperationClaimService.rate * claimLine.quantity;
          });
        }
      });
      this.totalValueOfAllOperation =  total.toFixed(2);
      // sync order.claimlinesTotal in the order table
      if(this.operations.length > 0){
        this.order.claimLinesTotal = total.toFixed(2);
      }
    },
    removeOperation(operation, changeTab = true) {
      this.operations.splice(this.operations.indexOf(operation), 1);
      if (changeTab)
      this.tabs.active = this.tabs.active - 1
    }
  }
};
</script>

<style lang="scss">
.order-operations {
  .loading-overlay.is-active {
    z-index: 9;
  }
  /* .notes {
    overflow-y: scroll;
    overflow-x: visible;
  } */
  .tabs {
    ul > li:nth-child(2) > a, ul > li:nth-child(3) > a {
      border: none;
      padding: 0 0 0 1em;
      margin-bottom: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Order/OrderOperations.vue